var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3871 8.99874L17.4183 0.617495C17.5362 0.478209 17.4371 0.266602 17.2549 0.266602H15.1174C14.9916 0.266602 14.871 0.322851 14.788 0.41928L8.98887 7.33267L3.18977 0.41928C3.10941 0.322851 2.98887 0.266602 2.8603 0.266602H0.722801C0.540658 0.266602 0.441551 0.478209 0.559408 0.617495L7.59066 8.99874L0.559408 17.38C0.533007 17.411 0.51607 17.449 0.510607 17.4894C0.505143 17.5298 0.511383 17.5709 0.528587 17.6078C0.54579 17.6448 0.573234 17.676 0.60766 17.6978C0.642086 17.7196 0.682048 17.7311 0.722801 17.7309H2.8603C2.98619 17.7309 3.10673 17.6746 3.18977 17.5782L8.98887 10.6648L14.788 17.5782C14.8683 17.6746 14.9889 17.7309 15.1174 17.7309H17.2549C17.4371 17.7309 17.5362 17.5193 17.4183 17.38L10.3871 8.99874Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.07f7cbca68d14b4bf23e28338a06965c.svg";
export { ForwardRef as ReactComponent };